import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import RenderProforma from "../../containers/ManegeProcedure/RenderProforma";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import { validateArray } from "../../utils/validate";
import { Tooltip } from "react-tippy";
import ListDocument from "../../components/common/ListDocument";
import ListDocumentVerify from "../../components/common/ListDocumentVerify";
import { FormQuotes } from "../../containers/ManegeProcedure/FormQuotes";
import { GenerateRoadmapPDF } from "../../containers/ManegeProcedure/GenerateRoadmapPDF";
import { QuoteComparison } from "./QuoteComparison";
import { PurchaseOrder } from "./PurchaseOrder";
import { FormInsuranceApplication } from "../../containers/ManegeProcedure/FormInsuranceApplication";
import { FormTransportContract } from "../../containers/ManegeProcedure/FormTransportContract";

const TableLisDocument = ({
  listButton,
  procedure,
  reload,
  handleSendProcedure,
}) => {
  const { openDialog, dialogClose } = useDialog();
  const { openModal, onClose } = useModal();

  function listDocumentPdf(procedure) {
    openDialog(<RenderPdf procedure={procedure} />);
  }
  function generateSettlementProforma(procedure) {
    openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  }

  function generateProforma(procedure) {
    openModal(<FormQuotes procedure={procedure} />);

    // openDialog(<RenderProforma procedure={procedure} />);
  }

  function generateRoadmap(procedure) {
    openDialog(<GenerateRoadmapPDF procedure={procedure} />);

    // openDialog(<GenerateRoadmap procedure={procedure} />);
  }
  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} />);
  }
  function handleDocumentVerify(procedure) {
    openModal(<ListDocumentVerify procedure={procedure} />);
  }

  function handleQuoteComparison(procedure) {
    openDialog(<QuoteComparison procedureId={procedure.id} />);
  }

  function handlePurchaseOrder(procedure) {
    openDialog(<PurchaseOrder procedureId={procedure.id} />);
  }

  function handleInsuranceApplication(procedure) {
    openModal(
      <FormInsuranceApplication
        procedure={procedure}
        reload={reload}
        handleSendProcedure={handleSendProcedure}
      />,
    );
  }

  function handleTransportContract(procedure) {
    openModal(<FormTransportContract procedure={procedure} />);
  }

  let listGeneralButtons = [
    {
      label: "Comparación de cotizaciones",
      icon: "fa-solid fa-chart-column",
      Name: "quote-comparison",
      action: handleQuoteComparison,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Orden de compra",
      icon: "fa-solid fa-file-invoice-dollar",
      Name: "purchase-order",
      action: handlePurchaseOrder,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Solicitud de seguro",
      icon: "fa-solid fa-shield-alt",
      Name: "insurance-application",
      action: handleInsuranceApplication,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Formulario de contrato de transporte",
      icon: "fa-solid fa-file-contract",
      Name: "transport-contract",
      action: handleTransportContract,
      color: "text-[#f59e0b]",
    },
  ];

  return (
    <>
      {validateArray(listButton)
        ? listButton.map((btn, index) => {
          const button = listGeneralButtons.find(
            (element) => element.Name === btn.Name,
          );
          if (button === undefined) {
            return null;
          }
          return (
            <div
              key={index}
              className={`${button.color} text-xl cursor-pointer`}
              onClick={() => button.action(procedure)}
            >
              <Tooltip
                title={button.label}
                position="right"
                trigger="mouseenter"
              >
                <i className={button.icon + " p-1"}></i>
              </Tooltip>
            </div>
          );
        })
        : null}
    </>
  );
};

export default TableLisDocument;
